var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc"},[_c('img',{staticStyle:{"width":"292px","margin":"0 auto 25px"},attrs:{"src":require("../../../static/empty.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"color9"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f79348c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData/index.vue
// module id = null
// module chunks = 